<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="guide_id" label="Guide">
                <select3 :value="form.guide" @input="setGuide" allow-clear data-url="/api/guides/guides" value-key="name"></select3>
            </form-input>

            <form-input :form="form" property="name"></form-input>
            <form-input :form="form" property="slug"></form-input>
            <form-input :form="form" property="title"></form-input>

            <form-input :form="form" property="meta_description">
                <textarea v-model="form.meta_description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="description">
                <textarea v-model="form.description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="body">
                <text-editor v-model="form.body"></text-editor>
            </form-input>

            <form-input :form="form" property="image" label="Photo">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>

            <form-input-trans :form="form" property="image.alt"></form-input-trans>

        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';
import axios from 'axios';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            method: '/api/guides/categories',
            form: new Form(() => {
                return {
                    name: null,
                    title: null,
                    slug: null,
                    meta_description: null,
                    description: null,
                    body: null,
                    image: {
                        alt: {}
                    },
                    guide:null,
                    guide_id:null,
                };
            }),
            slug: '',
            validSlug: '',
        };
    },
    mounted() {

    },
    methods: {
        setGuide: function(guide) {

            if (guide) {
                this.form.guide = guide;
                this.form.guide_id = guide.id;

            } else {
                this.form.guide = null;
                this.form.guide_id = null;
            }
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/guides/Category.vue